/**
 * Übergangs-Aktionen des Wizards: "Weiter" aus Schritt 2 (persistiert "Als
 * Standard merken"-Feld-Rezepte) und die Erfolgs-Toast-Aktion nach Laufstart.
 */

import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import { toast } from 'sonner'

import { useFieldRecipeMutations } from '../hooks/useFieldRecipeMutations'
import type { useWizardState } from './useWizardState'

export function useWizardActions(wizard: ReturnType<typeof useWizardState>) {
  const { t } = useTranslation()
  const [searchParams, setSearchParams] = useSearchParams()
  const { upsert } = useFieldRecipeMutations()

  const goNext = () => {
    if (wizard.step === 1) {
      for (const channelId of wizard.selectedChannelIds) {
        const fields = wizard.fieldSelections[channelId] ?? {}
        for (const [attributeCode, selection] of Object.entries(fields)) {
          if (selection.enabled && selection.rememberDefault) {
            upsert.mutate({
              channel_id: channelId,
              attribute_code: attributeCode as never,
              template_id: selection.templateId,
              settings: selection.systemToolCode ? { system_tool_code: selection.systemToolCode } : undefined,
            })
          }
        }
      }
    }
    wizard.setStep(Math.min(2, wizard.step + 1))
  }

  const handleStarted = () => {
    toast.success(t('channelContent.wizard.started'), {
      action: {
        label: t('channelContent.wizard.openQueue'),
        onClick: () => {
          const next = new URLSearchParams(searchParams)
          next.set('tab', 'runs')
          setSearchParams(next)
        },
      },
    })
  }

  return { goNext, handleStarted }
}
